import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import events from 'lib/events';
import Header from 'components/layout/header';
import session from 'services/sessionService';
import AnalysisDateRange from './analysisDateRange';
import ReactSelect from 'react-select';
import csvApi from 'api/csv';
import branchApi from 'api/branch';
import DeviceTools from 'page/tools/devices';
import AccountTools from 'page/tools/accounts';
import DatabaseTools from 'page/tools/database';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import {dateTimeFormats} from 'helpers/constants';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

const ALL = {value: 'All', label: 'All'};

let render = (container) => {
  console.info('[UI.page.tools.calibration] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperDatabaseExport /></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.calibration] register route');
router.rr.add([{path: 'tools/export', handler: routeUtils.requireAuth(render)}]);

class DatabaseExport extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    branches: null,
    history: null,
    branchesOptions: [],
    branchesSelected: [],
  };

  componentWillMount() {
    ALL.label = this.props.intl.formatMessage({id: 'general.all'});
  }

  componentDidMount() {
    csvApi.exportHistory()
      .then((response) => this.setState({history: response}));
    branchApi.getMyBranches()
      .then((response) => {
        this.setState({branches: response});
        let options = [ALL].concat(response.map(({id, name}) => ({label: name, value: id})));
        let selected = [ALL];

        this.setState({branchesOptions: options, branchesSelected: selected});
      });
  }

  handleExport = () => {
    var selectedBranchIds;

    if (this.state.branchesSelected == null) {
      events.publish('error.user', {
        message:
  <span>
    <FormattedMessage id="tools.database.select.store" />
  </span>
        ,
      });
    } else {
      if (this.state.branchesSelected[0].value === 'All') {
        selectedBranchIds = this.state.branchesOptions.map((o) => o.value);
        //Cut 'All' from the options before sending
        selectedBranchIds.splice(0, 1);
      } else {
        selectedBranchIds = this.state.branchesSelected.map((o) => o.value);
      }
      csvApi.export({
        branchIds: selectedBranchIds,
        poolTypes: [
          this.refs.exportPools.checked ? 1 : null,
          this.refs.exportSpas.checked ? 2 : null,
          this.refs.exportSwimSpas.checked ? 3 : null,
        ].filter((x) => !!x),
        allAnalyses: this.refs.analysisCreatedRange.all(),
        analysisCreatedStart: this.refs.analysisCreatedRange.start(),
        analysisCreatedEnd: this.refs.analysisCreatedRange.end(),
      }).then(() => events.publish('success.user', {
        message:
  <span>
    <FormattedMessage id="tools.database.export.started" />
  </span>
        ,
      }));
    }
  };

  updateFilter = () => {
    return selectedOptions => {

      // Ensure that 'All' cannot be selected along with other values in a multiselect
      if (Array.isArray(selectedOptions) && Array.isArray(this.state.branchesSelected)) {
        let prevIndexOfAll = this.state.branchesSelected.indexOf(ALL);
        let currentIdxOfAll = selectedOptions.indexOf(ALL);

        // If 'ALL' is being added to the selected options, then force it to be the only option selected
        if (currentIdxOfAll !== -1 && prevIndexOfAll === -1) {
          selectedOptions = [selectedOptions[currentIdxOfAll]];
        // Remove 'ALL', when the user is trying to add another option
        } else if (currentIdxOfAll !== -1 && selectedOptions.length > 1) {
          selectedOptions.splice(currentIdxOfAll, 1);
        }
      }

      let selected = Object.assign({}, this.state.branchesSelected);

      selected = selectedOptions;
      this.setState({branchesSelected: selected});
    };
  };

  render() {
    let {formatMessage} = this.props.intl;
    const {branches, history} = this.state;
    let exportHistory;

    if (history !== null) {
      exportHistory = history.map((history, index) => {
        let date = moment(history.Created).format(dateTimeFormats.numeralDateTime);

        return (
          <tr key={index}>
            <td>{date}</td>
            {(() => {
              if (history.Completed != null) {
                return <td><FormattedMessage id="general.completed" /></td>;
              }
              return <td><FormattedMessage id="general.pending" /></td>;
            })()}
            <td>{history.NotificationTitle}</td>
          </tr>
        );
      });
    }
    let subPages = {
      devices: {name: formatMessage({id: 'general.devices'}), element: <DeviceTools />, permissionLevel: 1000},
      accounts: {name: formatMessage({id: 'general.accounts'}), element: <AccountTools />, permissionLevel: 2000},
      database: {name: formatMessage({id: 'general.database'}), element: <DatabaseTools />, permissionLevel: 3000},
      // globalSystemUpdate: {name: 'Global System Update', element: <GlobalSystemUpdate />, permissionLevel: 3000},
    };

    let subPagesTabs = Object.keys(subPages)
      .filter(sp => subPages[sp].permissionLevel <= session.getUser().privileges.level)
      .map(sp => <a key={sp} className={sp === 'database' ? 'active' : ''}
                     href={'#tools/' + sp}>{subPages[sp].name}
      </a>);

    return (
      <div className='upload-page container'>
        <Header mainTitle={formatMessage({id: 'tools.title'})} subTitle={formatMessage({id: 'tools.database.export.title'})} mainTitleReturn='tools' />
        <nav className='navigation-tabs'>
          {subPagesTabs}
        </nav>
        <div className='row'>
          <div className='col-sm-12'>
            <h2><FormattedMessage id="tools.database.download.database" /></h2>
            <p><FormattedMessage id="tools.database.export.full" /></p>
            <div className='well'>
              <div className='row'>
                <div className='col-sm-4'>
                  <p><strong><FormattedMessage id="general.stores" />:</strong></p>
                  {branches ?
                    <ReactSelect name='branches' multi={true}
                      options={this.state.branchesOptions}
                      value={this.state.branchesSelected}
                                 placeholder={this.props.intl.formatMessage({id: 'general.select.store'})}
                      onChange={this.updateFilter()}/> :
                    null
                  }
                </div>
                <div className='col-sm-2'>
                  <p><strong><FormattedMessage id="general.pool.types" />:</strong></p>
                  <div className='form-group'>
                    <div className='checkbox-wrapper'>
                      <input type='checkbox' ref='exportPools' defaultChecked />
                      <label/>
                    </div>
                    <span className='pointer' onClick={() => this.refs.exportPools.checked = !this.refs.exportPools.checked}>
                      <FormattedMessage id="general.pools" />
                    </span>
                  </div>
                  <div className='form-group'>
                    <div className='checkbox-wrapper'>
                      <input type='checkbox' ref='exportSpas' defaultChecked />
                      <label/>
                    </div>
                    <span className='pointer' onClick={() => this.refs.exportSpas.checked = !this.refs.exportSpas.checked}>
                      <FormattedMessage id="general.spas" />
                    </span>
                  </div>
                  <div className='form-group'>
                    <div className='checkbox-wrapper'>
                      <input type='checkbox' ref='exportSwimSpas' defaultChecked />
                      <label/>
                    </div>
                    <span className='pointer' onClick={() => this.refs.exportSwimSpas.checked = !this.refs.exportSwimSpas.checked}>
                      <FormattedMessage id="general.swim.spas" />
                    </span>
                  </div>
                </div>
                <div className='col-sm-5 hidden'>
                  <p><strong><FormattedMessage id="tools.database.filter.analyses" />:</strong></p>
                  <div className='form-group'>
                    <AnalysisDateRange ref='analysisCreatedRange' />
                  </div>
                </div>
                <div className='col-sm-2'>
                  <p>&nbsp;</p>
                  <button className='btn btn-block btn-primary' onClick={this.handleExport}>{formatMessage({id: 'general.export'})}</button>
                </div>
              </div>
            </div>
            <h3 className='fake-table-header'><FormattedMessage id="tools.database.database.export" /></h3>
            <div className='well'>
              <table className='table table-striped user-table'>
                <thead>
                  <tr>
                    <th><FormattedMessage id="tools.database.date.time" /></th>
                    <th><FormattedMessage id="general.status" /></th>
                    <th><FormattedMessage id="general.user" /></th>
                  </tr>
                </thead>
                <tbody>
                  {exportHistory}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const WrapperDatabaseExport = bindLocaleUpdate(injectIntl(DatabaseExport));

export default WrapperDatabaseExport;
